import { Notification, NotificationChannel, NotificationExternalIdType } from '@nemuru-eng/js-api-client';

interface GetNotificationValuesByChannelProps {
  notificationChannel: NotificationChannel;
  notification: Notification;
}
export const getNotificationValuesByChannel = ({
  notificationChannel,
  notification,
}: GetNotificationValuesByChannelProps): { channelIconId: string; sentTo: string } | undefined => {
  switch (notificationChannel) {
    case NotificationChannel.MAILER:
      if (notification.channel === NotificationChannel.MAILER) {
        return {
          channelIconId: 'email',
          sentTo: notification.message.to[0].address,
        };
      }
      break;
    case NotificationChannel.TEXTER:
      if (notification.channel === NotificationChannel.TEXTER) {
        return {
          channelIconId: 'sms',
          sentTo: notification.message.phone,
        };
      }
      break;
    case NotificationChannel.CHATTER:
      return {
        channelIconId: 'question_answer',
        sentTo: '',
      };
    default:
      return {
        channelIconId: 'email',
        sentTo: '',
      };
  }
};

export const getNotificationsBySecondaryExternalIdType = (
  notifications: Notification[],
  secondaryExternalIdTypeArray: NotificationExternalIdType[],
): Notification[] =>
  notifications
    .filter((notification) => {
      if (notification.secondaryExternalIdType)
        return secondaryExternalIdTypeArray.includes(notification.secondaryExternalIdType);
    })
    .sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

export const BORROWER_NOTIFICATIONS = [
  NotificationExternalIdType.BORROWER,
  NotificationExternalIdType.BORROWER_ONBOARDING,
  NotificationExternalIdType.BUSINESS_ONBOARING,
];

export const AGENT_NOTIFICATIONS = [NotificationExternalIdType.AGENT];
